module.exports = __webpack_public_path__ + "ef6a81195e38128a9b6889bc20b9a1a1.svg";